import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import PageDocument from './PageDocument';

interface VerticalFrameProps {
    frameImage: string;
    content: string[];
    isPdf?: boolean;
    isMobile: boolean;
    isYoutube?: boolean;
}

function VerticalFrame(props: VerticalFrameProps) {
    const [contentIndex, setContentIndex] = useState(0);
    const { frameImage, content, isMobile } = props;

    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        window.addEventListener('resize', () => {
            setWindowHeight(window.innerHeight);
        });
    }, []);

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                overflow: 'hidden',
                display: 'flex',
            }}
        >
            {props.isPdf !== true &&
                <>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '20%',
                            height: 'fit-content',
                            cursor: 'pointer',
                            zIndex: 5,
                        }}
                    >
                        <IconButton
                            onClick={() => {
                                console.log('Setting content index to:', contentIndex - 1);
                                contentIndex - 1 < 0 ? setContentIndex(content.length - 1) : setContentIndex(contentIndex - 1);
                            }}
                            sx={{
                                filter: 'brightness(1.4)',
                                transition: 'filter 0.5s',
                                '&:hover': {
                                    filter: 'brightness(1.8)',
                                },
                            }}
                        >
                            <ArrowBackIos
                                color="secondary"
                                sx={{
                                    filter: 'drop-shadow(0 0 8px #000)',
                                }}
                            />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            right: '20%',
                            height: 'fit-content',
                            cursor: 'pointer',
                            zIndex: 5,
                        }}
                    >
                        <IconButton
                            onClick={() => {
                                console.log('Setting content index to:', contentIndex + 1);
                                contentIndex + 1 >= content.length ? setContentIndex(0) : setContentIndex(contentIndex + 1);
                            }}
                            sx={{
                                filter: 'brightness(1.4)',
                                transition: 'filter 0.5s',
                                '&:hover': {
                                    filter: 'brightness(1.8)',
                                },
                            }}
                        >
                            <ArrowForwardIos
                                color="secondary"
                                sx={{
                                    filter: 'drop-shadow(0 0 8px #000)',
                                }}
                            />
                        </IconButton>
                    </Box>
                </>
            }
            <img
                src={frameImage}
                alt="Frame"
                style={{
                    width: '100%',
                    height: 'auto',
                    filter: 'brightness(1.5)',
                    transform: props.isPdf === true ? 'scale(1.08, 1)' : 'scale(1, 0.85)',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    top: props.isPdf === true ? '61.2%' : '49.8%',
                    left: '49.5%',
                    width: props.isPdf === true ? '71.4%' : '65.8%',
                    height: props.isPdf === true ? '100%' : '65.5%',
                    transform: 'translate(-50%, -50%)',
                    overflow: 'hidden',
                }}
            >
                {props.isPdf === true
                    && <PageDocument
                        file={content[contentIndex]}
                        height={isMobile
                            ? windowHeight * 0.50
                            : 889}
                        pages={81}
                    />
                }
                {props.isYoutube === true &&
                    <iframe
                        src={content[contentIndex]}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        title="YouTube Video"
                        style={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            border: 'none',
                        }}
                    />
                }
                {props.isPdf !== true && props.isYoutube !== true &&
                    <img
                        src={content[contentIndex]}
                        alt="Inner Content"
                        style={{
                            width: '100%',
                            height: 'auto',
                        }}
                    />
                }
            </Box>
        </Box>
    );
}

export default VerticalFrame;
